import React from "react";

const AuthLoader = ({ text = "Processing..." }) => {
  return (
    <div className="fixed inset-0 z-[9999] bg-black/40 backdrop-blur-[1px] flex items-center justify-center">
      <div className="bg-white rounded-lg shadow-md px-6 py-5 flex flex-col items-center gap-3">
        <div className="h-10 w-10 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
        <p className="text-sm text-gray-700 font-medium">{text}</p>
      </div>
    </div>
  );
};

export default AuthLoader;
